import { getToken } from "./auth-service";

export const doRequest = async (
  URL,
  resource,
  method,
  dados = "",
  urlParam = ""
) => {
  const params = {
    method: method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + (await getToken()),
    },
  };
  if (!["GET", "DELETE"].includes(method)) params.body = JSON.stringify(dados);
  return await fetch(URL + resource + urlParam, params);
};

export const doDataRequest = async (
  URL,
  resource,
  method,
  dados = "",
  urlParam = ""
) => {
  const data = new FormData();
  data.append("foto", dados.foto);
  const params = {
    method: method,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  };
  params.body = data;
  return await fetch(URL + resource + urlParam, params);
};

export const doPublicRequest = async (
  URL,
  resource,
  method,
  dados = "",
  urlParam = ""
) => {
  const params = {
    method: method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  // console.log(dados);
  // console.log(URL + resource + urlParam)
  if (!["GET", "DELETE"].includes(method)) params.body = JSON.stringify(dados);
  return await fetch(URL + resource + urlParam, params);
};
